import React from 'react';
import classes from './StepHeader.module.css';
import PageIndicatorArrow from '../../../../UI/PageIndicatorArrow/PageIndicatorArrow';

const StepHeader = (props) => {
  const headerStyle = {
    height: props.hideHeader ? 0 : '4.25rem',
    opacity: props.hideHeader ? 0 : 1
  };
  return (
    <div className={classes.Wrapper}>
      <div className={classes.PageIndicatorArrowWrapper}>
        <PageIndicatorArrow pageCount={props.pageCount} activePage={props.activeStep} />
      </div>
      <div className={classes.HeaderWrapper} style={headerStyle}>
        <div className={classes.Header}>{props.headerText}</div>
        <div className={classes.SubHeader}>{props.subheaderText}</div>
      </div>
    </div>
  );
};

export default StepHeader;



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/Steps/StepHeader/StepHeader.js